angular
  .module('app')
  .controller('MenuController', MenuController);

function MenuController($state, auth) {
  var vm = this;
  vm.logout = auth.logout;
}